import { useContext, useEffect } from "react";
import { AppContext } from "../../../Context/Context";
import useModaClose from "../../../hooks/useModalClose";
import Close from "../../../assets/icons/close.png";
import "./Layout.css";
import { getLocalStorageItem } from "../../../util/helper/helperFunctions";

const MODAL_ID = "customize-layout";

const LayoutPopup = () => {
  const { layoutPopup, setLayoutPopup, setIsMapDragEnable } =
    useContext(AppContext);

  const {
    showSaveDiscardLayout,
    setShowSaveDiscardLayout,
    isDefaultLayoutSelected,
    setIsDefaultLayoutSelected
  } = useContext(AppContext);

  useEffect(() => {
    setShowSaveDiscardLayout(showSaveDiscardLayout);
  }, [showSaveDiscardLayout]);

  const handleSelectLayout = (status) => {
    if (isDefaultLayoutSelected === status) {
      setLayoutPopup(false);
      return;
    }

    if (!status) {
      setIsMapDragEnable(false);
      document.body.classList.remove("no-drag");
    }

    setLayoutPopup(false);
    setIsDefaultLayoutSelected(status);
    setShowSaveDiscardLayout(true);
  };

  useModaClose(MODAL_ID, () => setLayoutPopup(false));

  return (
    <div id={MODAL_ID} className="customize-wrapper">
      <div className="layout-container">
        <div className="customize-modal-top-section">
          <h2>Layout</h2>
          <img
            onClick={() => setLayoutPopup(!layoutPopup)}
            src={Close}
            alt="close_icon"
          />
        </div>
        <div className="layout-selection-wrapper">
          <div
            className={`layout-option ${
              isDefaultLayoutSelected && !getLocalStorageItem("layout-order")
                ? "selected"
                : ""
            }`}
            onClick={() => handleSelectLayout(true)}
          >
            <div className="layout-text-container">
              <div className="right-content">
                <h3>Default</h3>
                <p>Standard LGV One layout</p>
              </div>
            </div>
          </div>

          <div
            className={`layout-option ${
              !isDefaultLayoutSelected && getLocalStorageItem("layout-order")
                ? "selected"
                : ""
            }`}
            onClick={() => handleSelectLayout(false)}
          >
            <div className="layout-text-container">
              <div className="right-content">
                <h3>Custom</h3>
                <p>Customize the layout according to your preferences</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LayoutPopup;
